import toggleScroll from './toggle-scroll.js';

const menuToggle = document.querySelector('.menu-toggle');
const siteHeader = document.querySelector('.site-header');
const mainNavWrapper = document.querySelector('.main-nav-wrapper');
const mainNavInner = document.querySelector('.main-nav-inner');
const mainNavBackdrop = document.querySelector('.main-nav-backdrop');

function toggleMenu(event) {
  event.preventDefault();

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  let mainNavHeight = mainNavInner.clientHeight;
  if (windowWidth > 767) {
    mainNavHeight = windowHeight - 80;
  }

  if (siteHeader.classList.contains('menu-opened')) {
    siteHeader.classList.remove('menu-opened');
    mainNavBackdrop.classList.remove('menu-opened');
    mainNavWrapper.style.height = '0px';
    toggleScroll('enable');
    siteHeader.classList.add('menu-closing');
    setTimeout( ()=> {
      siteHeader.classList.remove('menu-closing');
      if (window.scrollY > 25) {
        siteHeader.classList.add('is-sticky');
      }
    },350);

  } else {
    siteHeader.classList.remove('is-hidden');
    siteHeader.classList.add('menu-opened');
    mainNavWrapper.style.height = `${mainNavHeight}px`;
    mainNavBackdrop.classList.add('menu-opened');
    toggleScroll('disable');
  }

  return false;
}

menuToggle.addEventListener('click', toggleMenu);
mainNavBackdrop.addEventListener('click', toggleMenu);
